import SvgIcon, { SvgIconProps } from "./SvgIcon";

const ColoredSunbedIcon: React.FC<SvgIconProps> = ({ variant, ...props }) => {
  return (
    <SvgIcon {...props}>
      {variant == "outlined" ? (
        <>
          <path
            d="M17.6461 2.19443C15.817 1.52129 13.7848 1.58929 11.9965 2.3835C10.2082 3.1777 8.81033 5.11924 8.11035 6.91558L15.007 9.45385L21.9037 11.9921C22.6035 10.1957 22.5482 7.71934 21.7498 5.97311C20.9513 4.22688 19.4752 2.86766 17.6461 2.19443Z"
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#FF6666"
          />
          <path
            d="M18.3591 10.5427C20.1173 5.49941 19.6104 3.23154 17.5924 1.97375C15.5754 1.47209 13.6033 3.14717 11.5502 7.77839"
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#FF6666"
          />
          <path
            d="M18.2397 1L10.5 20"
            strokeWidth="1.7"
            strokeLinecap="round"
            stroke="#FF6666"
          />
          <path
            d="M19.5128 15.0828H6.64783C6.42151 15.0828 6.20772 14.9789 6.0679 14.8009L3.38021 11.3802L3.04024 11.0402C2.34403 10.344 1.15785 10.8942 1.23961 11.8754C1.25586 12.0704 1.32593 12.257 1.442 12.4146L4.74595 16.8985C4.88496 17.0871 5.10536 17.1985 5.3397 17.1985H19.5128C19.8457 17.1985 20.1593 17.0417 20.3591 16.7754C20.6412 16.3992 20.6412 15.8821 20.3591 15.5059C20.1593 15.2395 19.8457 15.0828 19.5128 15.0828Z"
            strokeWidth="1.5"
            stroke="#262626"
            fill="transparent"
          />
          <path
            d="M1.52893 20.3721H23.4798M18.5128 17.1985V20.1076M6.28936 17.1985V20.1076"
            strokeWidth="1.5"
            strokeLinecap="round"
            stroke="#262626"
          />
        </>
      ) : (
        <>
          <path
            d="M17.6461 2.19443C15.817 1.52129 13.7848 1.58929 11.9965 2.3835C10.2082 3.1777 8.81033 5.11924 8.11035 6.91558L15.007 9.45385L21.9037 11.9921C22.6035 10.1957 22.5482 7.71934 21.7498 5.97311C20.9513 4.22688 19.4752 2.86766 17.6461 2.19443Z"
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#FF6666"
          />
          <path
            d="M18.3591 10.5427C20.1173 5.49941 19.6104 3.23154 17.5924 1.97375C15.5754 1.47209 13.6033 3.14717 11.5502 7.77839"
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#FF6666"
          />
          <path
            d="M18.2397 1L10.5 20"
            strokeWidth="1.7"
            strokeLinecap="round"
            stroke="#FF6666"
          />
          <path
            d="M6.64783 15.0828H19.5128C19.8457 15.0828 20.1593 15.2395 20.3591 15.5059C20.6412 15.8821 20.6412 16.3992 20.3591 16.7754C20.1593 17.0417 19.8457 17.1985 19.5128 17.1985H5.3397C5.10536 17.1985 4.88496 17.0871 4.74595 16.8985L1.442 12.4146C1.32593 12.257 1.25586 12.0704 1.23961 11.8754C1.15785 10.8942 2.34403 10.344 3.04024 11.0402L3.38021 11.3802L6.0679 14.8009C6.20772 14.9789 6.42151 15.0828 6.64783 15.0828Z"
            fill="#FF6666"
            fillOpacity="0.5"
            strokeWidth="1.5"
            stroke="#262626"
          />
          <path
            d="M1.52893 20.3721H23.4798M18.5128 17.1985V20.1076M6.28936 17.1985V20.1076"
            strokeWidth="1.5"
            strokeLinecap="round"
            stroke="#262626"
          />
        </>
      )}
    </SvgIcon>
  );
};

export default ColoredSunbedIcon;
